/* eslint-disable react/no-danger */
import React from 'react';

export default ({
  customColumnsText: { title, subtitle, list, additionalInfo },
  borderTop,
  borderBot,
  pythonMode,
  withImg
}) => {
  return (
    <div
      className={`container pb-5 ${borderTop &&
        'border-top py-5'} ${borderBot && 'border-bottom'} ${
        pythonMode ? 'my-5' : ''
      }`}
    >
      <div className="row">
        <div className="col flex-column">
          <h2 className="subtitle without bigger">{title}</h2>
          <div className="content">
            <p>{subtitle}</p>
          </div>
        </div>
      </div>
      <div className="row">
        <div
          className="col d-md-flex mt-2 text-justify justify-content-between text-format"
          dangerouslySetInnerHTML={{
            __html: list
          }}
        />
      </div>
      {additionalInfo && (
        <div className="row">
          <div className="col">
            <div className="extra">{additionalInfo}</div>
          </div>
        </div>
      )}
    </div>
  );
};
